import { Component, OnInit, AfterContentInit } from '@angular/core';
import { FabricantedeService } from 'src/app/pages/cadastros/services/fabricante.service';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsuarioService } from 'src/app/services/usuario.service';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';

@Component({
  selector: 'app-fabricante',
  templateUrl: './fabricante.component.html',
  providers: [FabricantedeService]
})
export class FabricanteComponent implements OnInit, AfterContentInit {


  public cadastrados: any[] = [];

  public form: FormGroup = null;
  public id = 0; // representa o id do modelo. Se 0 novo cadastro, Se > 0 editando
  public isProcessing = false;
  public isEditing = false;
  public voids: string[] = [];
  public maxRowsVoids = 7;

  public autorizacoes: UsuarioAutorizacoes;

  constructor(
    private fabricanteService: FabricantedeService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private usuarioService: UsuarioService

  ) { }

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('fabricante');
  }

  ngOnInit() {
    this.list(); // carrega lista de já cadastrados
    this.resetForm(); // instancia o formulário utilizado (formGroup)
  }

  public list(): void {
    this.fabricanteService.list().subscribe((response: any) => {
      this.cadastrados = response;
      this.setVoids();
    });
  }

  public resetForm(): void {
    this.form = new FormGroup(
      {
        id: new FormControl(0),
        nome: new FormControl(null, [Validators.required])
      }
    );
  }

  public reset(): void {
    this.id = 0;
    this.isProcessing = false;
    this.isEditing = false;
    this.resetForm();
  }

  public read(id: number): void {

    this.reset();
    this.isProcessing = true;

    this.fabricanteService.read(id).subscribe(

      (response: any) => {
        this.form.get('nome').setValue(response.nome);
        this.form.get('id').setValue(response.id);
        this.id = id;
        this.isEditing = true;
        this.isProcessing = false;
      },
      (error: any) => {
        this.showError(error);
      },
    );
  }

  public submit(): void {

    this.isProcessing = true;

    if (this.form.get('id').value === 0) {
      this.fabricanteService.isUniqueNomeFabricante(this.form.get('nome').value).subscribe(

        (isUniqueNomeFabricante: boolean) => {

          if (isUniqueNomeFabricante) {
            this.save();
          } else {
            this.form.get('nome').setErrors({ isNotUniqueNomeFabricante: true });
            this.isProcessing = false;
          }
        },
        (error: any) => { this.showError(error); }
      );
    } else {
      this.save();
    }

  }

  private save() {
    this.fabricanteService.create(this.form.value).subscribe(

      (response: any) => {

        if (response.success == true) {
          this.toastr.success(response.message);
        } else {
          this.toastr.warning(response.message);
        }
        this.reset();
        this.list();
      },
      (error: any) => {
        this.showError(error);
      }
    );

  }


  public setVoids(): void {
    this.voids = [];
    if (this.cadastrados.length < this.maxRowsVoids) {
      for (let i = this.cadastrados.length; i < this.maxRowsVoids; i++) { this.voids.push(''); }
    }
  }

  public showModalSm(modal: any) {
    this.modalService.open(modal, { windowClass: 'smModal', backdrop: 'static'  });
  }

  public delete(id: number, c: any): void {

    this.isProcessing = true;
    c('Close click');

    this.fabricanteService.delete(id).subscribe(

      (response: any) => {

        if (response.success == true) {
          this.toastr.success(response.message);
        } else {
          this.toastr.warning(response.message);
        }
        this.reset();
        this.list();
      },
      (error: any) => {
        this.showError(error);
      }
    );
  }

  public showError(error: any) {

    this.form.get('nome').setErrors({ hasError: true });

    if (error.error.errors) {
      this.toastr.error(error.error.errors[0].message);
    } else {
      this.toastr.error('Ocorreu um erro no servidor');
    }

    this.isProcessing = false;
  }

}
